import { css } from 'styled-components'
import ofc from '../../settings/variables'
const styles = css`
    width:100%;
    background-color: ${ofc.bgLight};
    box-shadow:0 -1em 1em 0 rgba(0,0,0,0.1) ;
`

export default styles
    